import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';

import AnimalType from './../../containers/AnimalType/AnimalType';
import Breed from './../../containers/Breed/Breed';
import BirthDate from './../../containers/BirthDate/BirthDate';
import BreedWeight from './../../containers/BreedWeight/BreedWeight';
import Gender from './../../containers/Gender/Gender';
import Signalment from './../../containers/Signalment/Signalment';
import MainHeading from '../../containers/MainHeading/MainHeading';
import BodyCondition from '../../containers/BodyCondition/BodyCondition';
import BodyConditionHeading from '../../containers/BodyCondition/BodyConditionHeading';
import ConditionScore from '../../containers/ConditionScore/ConditionScore';
import WeightAdjustment from '../../containers/WeightAdjustment/WeightAdjustment';
import PhysicalActivity from '../../containers/PhysicalActivity/PhysicalActivity';
import Diagnoses from '../../containers/Diagnoses/Diagnoses';
import DiagnosesHeading from '../../containers/Diagnoses/DiagnosesHeading';
import CriticalCare from '../../containers/CriticalCare/CriticalCare';
import IdealBodyWeight from '../../containers/IdealBodyWeight/IdealBodyWeight';
import DiagnosesCards from '../../containers/Diagnoses/DiagnosesCards';
import FeedingGuidelines from '../../containers/FeedingGuidelines/FeedingGuidelines';
import DailyIntake from '../../containers/DailyIntake/DailyIntake';
import DevTools from '../../containers/DevTools/DevTools';
import Diet from '../../containers/Diet/Diet';
import PetInfo from '../../containers/PetInfo/PetInfo';
import GenerateFeedingGuidlines from '../../containers/FeedingGuidelines/Generate';
import Products from '../../containers/Products/Products';
import DailyWet from '../../containers/DailyWet/DailyWet';
import PdfOutput from '../../containers/FeedingGuidelines/PdfOutput';
import PdfOutputModal from '../../containers/FeedingGuidelines/PdfOutputModal';
import Loader from './../Loader/Loader';
import Help from './../../containers/Help/Help';

class MainLayout extends Component {

  render() {
    const {displayFeedingGuidelines} = this.props;
    const appElement = document.getElementById("nppe2-feeding-calc-react-app");

    return (
      <div>

        <Help/>

        {displayFeedingGuidelines ? (
          <div className="nppe2-fc-feeding-guidelines-outer">
            <div className="feeding-guidelines-container nppe2-fc">
              <FeedingGuidelines/>
            </div>
          </div>
        ) : (
          null
        )}

        {
          <div className="nppe2-fc-feeding-guidelines-outer">
            <ReactModal
              className="nppe2-fc-help-modal"
              closeTimeoutMS={270}
              shouldFocusAfterRender={false}
              appElement={appElement}
              style={{
                overlay: {
                  backgroundColor: "rgba(0,0,0,0.75)",
                },
                content: {}
              }}
              isOpen={displayFeedingGuidelines}>

              <div id="nppe2-fc-feeding-guidelines-output">
                <PdfOutputModal/>
              </div>
            </ReactModal>
          </div>
        }

        <div className="container-fluid nppe2-fc">
          {/* App title and info modal */}
          <div className="row">
            <div className="col-xs-12">
              <MainHeading />
            </div>
          </div>

          {/* Main row with 3 columns - Start */}
          <div className="row">
            {/* First column - Start */}
            <div className="col-lg-4 col-md-8 col-xs-12">
              <div className="col-xs-12 nppe2-fc-main-column nppe2-fc-main-column__grey">
                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 1 - Start */}
                    <AnimalType />
                    {/* Component 1 - End */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 2 - Start */}
                    <Breed />
                    {/* Component 2 - Start */}

                    {/* Component 3 - Start */}
                    <BirthDate />
                    {/* Component 3 - End */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 5 - Start */}
                    <Gender />
                    {/* Component 5 - End */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12">
                    <hr />
                    <Signalment />
                   
                  </div>
                </div>
              </div>
            </div>
            {/* First column - End */}

            {/* ##################### */}

            {/* Second column - Start */}
            <div className="col-lg-4 col-md-8 col-xs-12">
              {/* First grey box - Start */}
              <div className="col-xs-12 nppe2-fc-main-column nppe2-fc-main-column__grey">
                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 8 - Start */}
                    <BodyConditionHeading />
                    {/* Component 8 - End */}
                  </div>

                  <div className="col-xs-11 col-sm-7">
                    {/* Component 9 - Start */}
                    <BodyCondition />
                    {/* Component 9 - End */}

                    {/* Component 10 - Start */}
                    <ConditionScore />
                    {/* Component 10 - End */}
                  </div>

                  <div className="col-xs-12 col-sm-5">
                    {/* Component 11 - Start */}
                    <IdealBodyWeight />
                    {/* Component 11 - End */}
                  </div>

                  <div className="col-xs-12">
                    <hr />

                    {/* Component 12 - Start */}
                    <WeightAdjustment />
                    {/* Component 12 - End */}
                  </div>
                </div>
              </div>
              {/* First grey box - End */}

              {/* Second grey box - Start */}
              <div className="col-xs-12 nppe2-fc-main-column nppe2-fc-main-column__grey">
                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 13 - Start */}
                    <PhysicalActivity />
                    {/* Component 13 - Start */}
                  </div>
                </div>
              </div>
              {/* Second grey box - End */}

              {/* Third grey box - Start */}
              <div className="col-xs-12 nppe2-fc-main-column nppe2-fc-main-column__grey">
                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 14 - Start */}
                    <DiagnosesHeading />
                    <hr />
                    {/* Component 14 - End */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6 col-xs-12">
                    {/* Component 15 - Start */}
                    <Diagnoses />
                    {/* Component 15 - End */}
                  </div>
                  <div className="col-sm-6 col-xs-12">
                    {/* Component 16 - Start */}
                    <CriticalCare />
                    {/* Component 16 - End */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 17 - Start */}
                    <DiagnosesCards />
                    {/* Component 17 - End */}
                  </div>
                </div>
              </div>
              {/* Third grey box - End */}
            </div>
            {/* Second column - End */}

            {/* ##################### */}

            {/* Third column - Start */}
            <div className="col-lg-4 col-md-4 col-xs-12 nppe2-fc-main-column-absolute">
              <div className="col-xs-12 nppe2-fc-main-column nppe2-fc-main-column__white">

                <div className="row">
                  <div className="col-xs-12">
                    {/* Component 18 - Start */}
                    <DailyIntake />
                    {/* Component 18 - End */}
                  </div>
                </div>

                {/* Component 19 - Start */}

                <PetInfo/>


                {/* Component 19 - End */}

                <div className="row nppe2-fc-mt-0">
                  <div className="col-xs-12">

                    {/* Component 20 - Start */}
                    <Diet/>
                    {/* Component 20 - End */}

                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12">

                    {/* Component 21 - Start */}
                    <div className="nppe2-fc-type-of-food" id="nppe2-fc-validate-products">
                      <Products/>
                    </div>
                    {/* Component 21 - End */}

                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12">

                    {/* Component 22 - Start */}
                    <DailyWet />

                    {/* Component 22 - End */}

                  </div>
                </div>

                {/* Component 24 - Start */}
                <GenerateFeedingGuidlines/>
                {/* Component 24 - End */}

              </div>
            </div>
            {/* Third column - End */}


          </div>
          {/* Main row with 3 columns - End */}
          <DevTools/>
        </div>
      </div>
    );

  }
}

const mapStateToProps = state => {
  return {
    displayFeedingGuidelines: state.feedingGuidelinesGenerateReducer.displayFeedingGuidelines,
  }
};

export default connect(mapStateToProps)(MainLayout);

/*

*/